// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const poochyena: PokeData = {
  "id": 261,
  "name": "poochyena",
  "height": 5,
  "weight": 136,
  "base_experience": 56,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "leer",
    "bite",
    "roar",
    "thief",
    "scary-face",
    "mud-slap",
    "swagger",
    "crunch",
    "taunt",
    "yawn",
    "odor-sleuth",
    "howl",
    "assurance",
    "embargo",
    "sucker-punch",
    "play-rough"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "leer",
    "bite",
    "scary-face",
    "mud-slap",
    "crunch",
    "play-rough",
    "lash-out",
    "flatter",
    "pursuit",
    "dark-bargain",
    "night-daze"
  ],
  "evolution_chain": {
    "id": 133,
    "item": null,
    "species": [
      {
        "name": "poochyena",
        "order": 286,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mightyena",
        "order": 287,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 261,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 33.75,
    "speed": 35,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
